import { useState } from "react";
import { observer } from "mobx-react";
import { Nav, NavItem } from "reactstrap";
import { NavLink, useMatch } from "react-router-dom";

import { AzureAuth, UserPermissions } from "@app/Classes/AzureAuth";
import { devInfoStore } from "@app/Stores/DevInfoStore";
import { Icon } from "../Icon";
import "./_nav-sidebar.scss";

const COLLAPSED_KEY = 'irreg.navSidebar.collapsed';

function readCollapsed() {
    return localStorage.getItem(COLLAPSED_KEY) === 'true';
}

export const NavSidebar = observer(() => {
    const hasAccessToAdminTools = AzureAuth.hasAccess(UserPermissions.AdminToolsRead);
    const hasAccessToMasterData = AzureAuth.hasAccess(UserPermissions.MasterDataRead);
    const hasAccessToEmails = AzureAuth.hasAccess(UserPermissions.EmailsRead);
    const hasAccessToConfigs = AzureAuth.hasAccess(UserPermissions.AdminToolsWrite);

    const [isCollapsed, setIsCollapsed] = useState(readCollapsed);
    const toggleCollapsed = () => {
        setIsCollapsed((prev) => {
            const next = !prev;
               localStorage.setItem(COLLAPSED_KEY, String(next));
               return next;
        });
    };

    const isRoomDetailsView = useMatch('/case/:id') !== null;
    const classNames = ['nav-sidebar', `${devInfoStore.envClassName}`];
    if (isRoomDetailsView || isCollapsed) {
        classNames.push('compact');
    }

    return (
        <div className={classNames.join(' ')}>
            <Nav vertical pills>
                <NavItem>
                    <NavLink end to="/" className="nav-link" title="Flights">
                        <Icon name="table" />
                        <span className="nav-sidebar-title">Flights</span>
                    </NavLink>
                </NavItem>
                {hasAccessToAdminTools && (
                    <NavItem>
                        <NavLink end to="/health-board" className="nav-link" title="Health Board">
                            <Icon name="heart-pulse" />
                            <span className="nav-sidebar-title">Health Board</span>
                        </NavLink>
                    </NavItem>
                )}
                {hasAccessToAdminTools && (
                    <NavItem>
                        <NavLink end to="/jobs" className="nav-link" title="Jobs">
                            <Icon name="cogs" />
                            <span className="nav-sidebar-title">Jobs</span>
                        </NavLink>
                    </NavItem>
                )}
                {hasAccessToAdminTools && (
                    <NavItem>
                        <NavLink end to="/validation-rules" className="nav-link" title="Validation Rules">
                            <Icon name="pen-ruler" />
                            <span className="nav-sidebar-title">Validation Rules</span>
                        </NavLink>
                    </NavItem>
                )}
                {hasAccessToAdminTools && (
                    <NavItem>
                        <NavLink end to="/permissions-tool" className="nav-link" title="Permissions Tool">
                            <Icon name="user-secret" />
                            <span className="nav-sidebar-title">Permissions Tool</span>
                        </NavLink>
                    </NavItem>
                )}
                {hasAccessToMasterData && (
                    <NavItem>
                        <NavLink end to="/master-data" className="nav-link" title="Master Data">
                            <Icon name="star" />
                            <span className="nav-sidebar-title">Master Data</span>
                        </NavLink>
                    </NavItem>
                )}
                {hasAccessToMasterData && (
                    <NavItem>
                        <NavLink end to="/email-templates" className="nav-link" title="Email Templates">
                            <Icon name="envelopes-bulk" />
                            <span className="nav-sidebar-title">Email Templates</span>
                        </NavLink>
                    </NavItem>
                )}
                {hasAccessToEmails && (
                    <NavItem>
                        <NavLink end to="/email-viewer" className="nav-link" title="Email Viewer">
                            <Icon name="envelope" />
                            <span className="nav-sidebar-title">Email Viewer</span>
                        </NavLink>
                    </NavItem>
                )}
                {hasAccessToConfigs && (
                    <NavItem>
                        <NavLink end to="/configs" className="nav-link" title="Configs">
                            <Icon name="sliders" />
                            <span className="nav-sidebar-title">Configs</span>
                        </NavLink>
                    </NavItem>
                )}
                <NavItem>
                    <NavLink end to="/guideline" className="nav-link" title="How-To">
                        <Icon name="circle-question" />
                        <span className="nav-sidebar-title">How-To</span>
                    </NavLink>
                </NavItem>
            </Nav>
            <div
                className="nav-sidebar-toggle"
                onClick={toggleCollapsed}
                title={isCollapsed ? 'Expand menu' : 'Collapse menu'}
            >
                <Icon name={isCollapsed ? 'arrow-right' : 'arrow-left'} />
            </div>
        </div>
    );
});